<a
  [routerLink]="routerLink"
  routerLinkActive
  #rla="routerLinkActive"
  [ngClass]="
    rla.isActive
      ? 'group bg-surface rounded-md px-3 py-2 flex items-center text-sm leading-5 font-medium text-fg-primary hover:bg-surface-input focus:outline-none focus:bg-surface-input transition ease-in-out duration-150'
      : 'group rounded-md px-3 py-2 flex items-center text-sm leading-5 font-medium text-fg-primary hover:text-fg-primary hover:bg-surface focus:outline-none focus:text-fg-primary focus:bg-surface transition ease-in-out duration-150 print:hidden'
  "
>
  @if (rla.isActive) {
    <app-ng-icon [name]="iconOpenName" class="text-fg-primary text-xl mr-3"></app-ng-icon>
  } @else {
    <app-ng-icon
      [name]="iconName"
      class="text-fg-faint group-hover:text-fg-secondary group-focus:text-fg-secondary transition ease-in-out duration-150 text-xl mr-3"
    ></app-ng-icon>
  }

  <span class="truncate w-full" [ngClass]="rla.isActive ? 'text-fg-primary font-semibold' : 'text-fg-primary'">
    <ng-content></ng-content>
  </span>
</a>
